import { render } from "./DisiplinimiPage.vue?vue&type=template&id=7a8924d7&scoped=true"
import script from "./DisiplinimiPage.vue?vue&type=script&lang=js"
export * from "./DisiplinimiPage.vue?vue&type=script&lang=js"

import "./DisiplinimiPage.vue?vue&type=style&index=0&id=7a8924d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8924d7"]])

export default __exports__